<template>

    <v-page-body>

        <v-page-section padded>

            <template #title>{{ integration.name }}</template>

            <template #body>

                <transition name="modal">
                    <v-modal-integration-delete v-if="showModal === 'delete'" :id="projectIntegration.id" />
                </transition>

                <v-notice>
                    <template #body>
                        <v-icon class="mb-15" :symbol="'action-' + integration.slug" :size="80" :radius="5" />
                        <p>{{ integration.description }}</p>
                    </template>
                    <template #footer>
                        <v-form>
                            <template #body>
                                <v-form-group dir="ver" label="Auth Token">
                                    <v-input :model="params.access_token" @input="params.access_token = $event" />
                                </v-form-group>
                                <v-form-group dir="ver" label="Account SID">
                                    <v-input placeholder="AC..." :model="params.auth.account_sid" @input="params.auth.account_sid = $event" />
                                </v-form-group>
                                <v-form-group dir="ver" label="Messaging Service SID">
                                    <v-input placeholder="MG..." :model="params.auth.messaging_service_sid" @input="params.auth.messaging_service_sid = $event" />
                                </v-form-group>
                                <v-form-group dir="ver" label="Incoming Webhook URL" caption="Set this URL to the delivery status callback and incoming message webhooks.">
                                    <v-copy-box>{{ integration.webhook_url }}</v-copy-box>
                                </v-form-group>
                            </template>
                            <template #footer>
                                <v-button v-if="projectIntegration" size="sm" btn-style="white-danger" @click.native="$store.commit('showModal', 'delete')">Remove</v-button>
                                <v-button size="sm" :loading="loading" @click.native="connect">Save Integration</v-button>
                            </template>
                        </v-form>
                    </template>
                </v-notice>

            </template>

        </v-page-section>

    </v-page-body>

</template>

<script>

import IntegrationApi from '@api/IntegrationApi';
import ModalIntegrationDelete from '@modals/misc/ModalIntegrationDelete';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal-integration-delete': ModalIntegrationDelete,
    },

    data() {
        return {
            slug: 'twilio',
            loading: false,
            integration: null,
            projectIntegration: null,
            params: {
                auth: {},
            },
        }
    },

    mounted() {
        this.getIntegration();
    },

    methods: {

        getIntegration() {
            this.$store.commit('loading', true);
            IntegrationApi.getIntegration(this.slug)
                .then((response) => {
                    this.integration = response.data.data;
                    this.getProjectIntegration();
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getProjectIntegration() {
            ProjectApi.getIntegration(this.project.id, this.slug)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.projectIntegration = response.data.data;
                    this.params = this.projectIntegration;
                    this.$events.$emit('pageLoaded');
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageLoaded');
                });
        },

        connect() {
            this.loading = true;
            ProjectApi.createIntegration(this.project.id, this.slug, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>